import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../common/hookFormComponents/FormSection';

const fields = [
  {
    colSpan: 1,
    name: 'cCountryOrManufacturer',
    label: 'Country/ Manufacturer',
  },
  {
    colSpan: 1,
    name: 'cYearOfManufacture',
    label: 'Year of Manufacture',
  },
  {
    fieldType: 'radio',
    colSpan: 1,
    name: 'cOption',
    defaultValue: 'New',
    choices: [
      { name: 'New', value: 'New' },
      { name: 'Re-conditioned', value: 'Re-conditioned' },
    ],
  },
];

export const CardingFieldsValidation = {
  [fields[0].name]: yup.string(),
  [fields[1].name]: yup.string(),
  [fields[2].name]: yup.string(),
};

const CardingSection = (props) => {
  return <FormSection sectionName="Carding" sectionColumn={3} formFields={fields} {...props} />;
};

export default CardingSection;
